export const BASE_URL = "https://tonpay.tech";
export const TESTNET_BASE_URL = "https://testnet.tonpay.tech";
